import { render } from "./AdminFacturation.vue?vue&type=template&id=37fc1615&scoped=true"
import script from "./AdminFacturation.vue?vue&type=script&lang=js"
export * from "./AdminFacturation.vue?vue&type=script&lang=js"

import "./AdminFacturation.vue?vue&type=style&index=0&id=37fc1615&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fc1615"]])

export default __exports__